import { days, DayTimetable, HeatingMode, IntervalTimetable, TimeInterval, WeekTimetable, } from 'z3k-config';
import { c2k, k2c } from 'utils';
import { compareInterval, intervalEndTimeSum, intervalStartTimeSum } from './utils';
import { mergeIntervals } from './time-line/transform';
import { partial } from 'webui/utils/functions';
import { objects2ids, seemsLikeObjectId } from 'z3k-parser/lib';
function intervalStartSum({ sh, sm }) {
    return sh * 60 + sm;
}
function intervalEndSum({ eh, em }) {
    return eh * 60 + em;
}
const initial_mode = {
    id: -1,
    name: 'неизвестный режим',
    setting_register: 0,
};
export function getTempOrMode(temp_or_mode, heating_modes, with_k2c = true) {
    //Если это особенные константы, то возвращаем их без изменений
    if (HeatingMode.special_modes.includes(temp_or_mode)) {
        return { temp: temp_or_mode, mode: undefined };
    }
    if (seemsLikeObjectId(temp_or_mode)) {
        const { id, name, setting_register } = heating_modes.find((hm) => hm.id === temp_or_mode) ?? initial_mode;
        return {
            temp: undefined,
            mode: {
                id,
                name,
                setting_register,
            },
        };
    }
    return {
        temp: with_k2c ? k2c(temp_or_mode) : temp_or_mode,
        mode: undefined,
    };
}
export function getTemperatureSetting(temp_or_mode) {
    const { temp, mode } = temp_or_mode;
    return temp != null
        ? HeatingMode.special_modes.includes(temp)
            ? temp
            : c2k(temp)
        : mode != null
            ? mode.id
            : 0;
}
function transform2DayIntervalType(heating_modes, time_interval) {
    const { sh, sm, eh, em, temperature } = time_interval;
    return {
        start_hour: sh,
        start_min: sm,
        end_hour: eh,
        end_min: em,
        temp_or_mode: getTempOrMode(temperature, heating_modes),
    };
}
function realIntervalType2TimeInterval(day_interval) {
    const { start_hour, start_min, end_hour, end_min, temp_or_mode } = day_interval;
    return {
        sh: start_hour,
        sm: start_min,
        eh: end_hour,
        em: end_min,
        temperature: getTemperatureSetting(temp_or_mode),
    };
}
function midnightTransformer(interval) {
    const { start_hour, start_min, end_hour, end_min } = interval;
    //Если конец интервала выходит за полночь (13:00 - 02:00)
    if (intervalStartSum({ sh: start_hour, sm: start_min }) >
        intervalEndSum({ eh: end_hour, em: end_min })) {
        //то бьём его на 2
        return [
            //xx:xx - 23:59
            {
                ...interval,
                start_hour,
                start_min,
                end_hour: 23,
                end_min: 59,
            },
            //00:00 - xx:xx
            {
                ...interval,
                start_hour: 0,
                start_min: 0,
                end_hour,
                end_min,
            },
        ];
    }
    return interval;
}
const full_day_empty = {
    start_hour: 0,
    start_min: 0,
    end_hour: 23,
    end_min: 59,
};
export function addEmptyInterval(intervals, selected_id) {
    let new_id = selected_id;
    // console.log('old_id', new_id);
    const intervals_without_empty = intervals
        .sort(compareInterval)
        .filter((interval, index) => {
        const is_need = 'temp_or_mode' in interval;
        if (!is_need && index < (selected_id ?? 0)) {
            // console.log('kyyyyy', new_id);
            new_id = new_id === null ? 0 : new_id - 1;
        }
        return is_need;
    });
    // console.log('new_id without empty', new_id);
    //Значит остались только пустые
    if (intervals_without_empty.length === 0) {
        return [null, [full_day_empty]];
    }
    // console.log('addEmptyInterval intervals_without_empty', intervals_without_empty);
    let interval_for_id = intervals_without_empty[new_id ?? 0];
    //Если удалили последний НЕПУСТОЙ элемент массива, то индекс промахнётся.
    //Возьмём предпоследний элемент, и определим его новый индекс
    if (interval_for_id == null) {
        new_id = intervals_without_empty.length - 1;
        interval_for_id = intervals_without_empty[new_id];
    }
    const items = [];
    for (let i = 0; i < intervals_without_empty.length; i++) {
        const interval = intervals_without_empty[i];
        const prev_interval = intervals_without_empty[i - 1];
        // console.log('step', i);
        // console.log('prev_interval', prev_interval, 'interval', interval);
        //самый первый элемент
        if (prev_interval == null) {
            if (intervalStartTimeSum(interval) > 0) {
                // console.log('!!!!!!!!!!!!!!!! START');
                items.push({
                    start_hour: 0,
                    start_min: 0,
                    end_hour: interval.start_hour,
                    end_min: interval.start_min,
                });
                new_id = new_id != null ? new_id + 1 : 0;
                // console.log('new_id start', new_id);
            }
            if (intervalEndTimeSum(interval) < 1439 &&
                intervals_without_empty.length === 1) {
                // console.log('last for 2');
                items.push({
                    start_hour: interval.end_hour,
                    start_min: interval.end_min,
                    end_hour: 23,
                    end_min: 59,
                });
            }
        }
        else {
            if (intervalStartTimeSum(interval) - intervalEndTimeSum(prev_interval) >
                0) {
                // console.log('middle');
                items.push({
                    start_hour: prev_interval.end_hour,
                    start_min: prev_interval.end_min,
                    end_hour: interval.start_hour,
                    end_min: interval.start_min,
                });
                // console.log('interval middle', interval, interval_for_id);
                if (intervalStartTimeSum(interval) <=
                    intervalStartTimeSum(interval_for_id)) {
                    new_id = new_id != null ? new_id + 1 : 0;
                    // console.log('new_id middle', new_id);
                }
            }
            if (intervalEndTimeSum(interval) < 1439 &&
                i === intervals_without_empty.length - 1) {
                // console.log('last');
                items.push({
                    start_hour: interval.end_hour,
                    start_min: interval.end_min,
                    end_hour: 23,
                    end_min: 59,
                });
            }
        }
    }
    // console.log('items', items);
    // console.log('new_id', new_id);
    return [new_id, [...intervals_without_empty, ...items].sort(compareInterval)];
}
/**
 * @function
 * на вход дают IntervalTimeTable
 * смотрим на массив time_intervals
 * из всех доступных TimeInterval'ов делаем расписание на 7 дней
 * для времени, не попавшем в интервалы, создаём «пустые» интервалы,
 * задаём для них дефолтное значение outside_default - температуру или режим
 * @param time_table - IntervalTimeTable: интервальное расписание
 * @param time_intervals - интервалы
 * @param heating_modes - режимы отопления
 * @return WeekSchedule - расписание на 7 дней
 */
export function intervalTimeTable2WeekSchedule(time_table, time_intervals, heating_modes, is_boiler) {
    //Составляю интервалы на все дни (7 x TimeInterval[])
    const intervals = days.map(({ id }) => time_intervals
        .filter((ti) => time_table.time_intervals.includes(ti.id))
        .filter(partial(TimeInterval.appliesToDay, id)));
    const DefaultTempOrMode = () => {
        //в котловых контурах при выборе варианта работы "интервальное расписание", по дефолту не ставилась температура, а ставилось "всегда"
        if (is_boiler && time_table.outside_default === 2930) {
            return getTempOrMode(HeatingMode.ALWAYS_ON_MODE, heating_modes);
        }
        return getTempOrMode(time_table.outside_default, heating_modes);
    };
    return {
        week: days.map(({ id }) => {
            const real_intervals = intervals[id]
                .map(partial(transform2DayIntervalType, heating_modes))
                .flatMap(midnightTransformer);
            const day_intervals = [...addEmptyInterval(real_intervals, null)[1]]
                //сортирую в порядке возрастания
                .sort(compareInterval);
            // console.log('day_intervals', day_intervals);
            return {
                key: id,
                day_intervals,
            };
        }),
        temp_or_mode: DefaultTempOrMode(),
    };
}
function createTempTimeInterval(week_day_interval) {
    return {
        ...realIntervalType2TimeInterval(week_day_interval),
        action_register: 0,
    };
}
function findAndChangeExistTempTimeInterval(exist_time_intervals, week_day_interval) {
    for (let i = 0; i < exist_time_intervals.length; i++) {
        const ti = exist_time_intervals[i];
        if (TimeInterval.isEqualTimeIntervals(ti, week_day_interval)) {
            return [i, ti];
        }
    }
    return null;
}
/**
 * @function
 * на вход дают недельное расписание
 * из него получаем заготовку для конфига
 * @param week_schedule - недельное расписание
 * @param exist_time_table - IntervalTimeTable: интервальное расписание (которое было)
 * @param exist_time_intervals - интервалы, которые были
 * @return заготовка для конфига
 */
export function weekSchedule2IntervalTimeTable(week_schedule, exist_time_table, exist_time_intervals) {
    const { week, temp_or_mode } = week_schedule;
    //Используемые ID в данном интервале
    const used_ids = exist_time_intervals.filter(({ id }) => exist_time_table.time_intervals.includes(id));
    // console.log('1 original', week);
    //1. выделяем все непустые интервалы
    const real_intervals = week.map((day) => ({
        ...day,
        day_intervals: mergeIntervals(day.day_intervals).filter((day_interval) => 'temp_or_mode' in day_interval),
    }));
    // console.log('2 real_intervals', real_intervals);
    let intervals = [];
    for (const { key, day_intervals } of real_intervals) {
        for (const interval of day_intervals) {
            //Преобразовать temp_or_mode обратно
            const new_interval = TimeInterval.setDay(key, createTempTimeInterval(interval));
            // console.log('new_interval', new_interval);
            //2. Если интервала такого нет, то создаю новый, если есть, то добавляю дни
            if (intervals.length === 0) {
                intervals.push(new_interval);
            }
            else {
                //Найти похожий интервал
                const index_found_interval = findAndChangeExistTempTimeInterval(intervals, new_interval);
                if (index_found_interval != null) {
                    //Указать дни, в который работает интервал
                    const [index, found_interval] = index_found_interval;
                    intervals = [
                        ...intervals.slice(0, index),
                        {
                            ...found_interval,
                            // Если дни недели разные, то добавляем новые 7 | 8 = 15
                            action_register: found_interval.action_register |
                                new_interval.action_register,
                        },
                        ...intervals.slice(index + 1),
                    ];
                }
                else {
                    // Если такого интервала нет, то создадим новый
                    intervals.push(new_interval);
                }
            }
        }
    }
    //смотрим на ID имеющихся интервалов
    const exist_ids = objects2ids(used_ids);
    //воспользуемся этими ID для новых интервалов
    const result_intervals = intervals.map((temp_ti, index) => {
        const exist_id = exist_ids[index];
        if (exist_id != null) {
            return { ...temp_ti, id: exist_id };
        }
        return temp_ti;
    });
    // console.log('result', result_intervals);
    //FIXME
    // Получилась заготовка для вставления в конфиг.
    // Теперь надо сгенерировать новые ID (для тех, у кого их нет)
    // и указать весь этот массив в IntervalTimetable.time_intervals
    return [
        { ...exist_time_table, outside_default: getTemperatureSetting(temp_or_mode) },
        result_intervals,
    ];
}
export function save2ConfigNewTimeInterval(config, temp_timetable) {
    const [timetable, time_intervals] = temp_timetable;
    // console.log('save2ConfigNewTimeInterval, config', config.counters);
    // console.log('save2ConfigNewTimeInterval, timetable', timetable);
    // console.log('save2ConfigNewTimeInterval, time_intervals', time_intervals);
    //Если интервалов стало меньше, то надо выкинуть ненужные
    const used_intervals_id = [];
    const config_with_ti = time_intervals.reduce((prev_config, ti) => {
        //Переиспользуем существующие ID
        if ('id' in ti) {
            // console.log('used', ti);
            used_intervals_id.push(ti.id);
            return TimeInterval.get.replaceById(prev_config, ti.id, ti);
            //Иначе создаём новые ID
        }
        else {
            // console.log('new');
            const [new_id, new_config] = TimeInterval.get.add(prev_config, ti);
            used_intervals_id.push(new_id);
            return new_config;
        }
    }, config);
    // console.log('save2ConfigNewTimeInterval, config_with_ti', config_with_ti.counters);
    // console.log('save2ConfigNewTimeInterval, used_intervals_id', used_intervals_id);
    return IntervalTimetable.get.applySetterById(config_with_ti, timetable.id, {
        outside_default: timetable.outside_default,
        //Ссылаемся лишь на те ID, что используем
        time_intervals: used_intervals_id,
    });
}
/**
 * @function
 * 25.03.2022 для приложения BAXI решили оставить только интервальные расписания
 * Теперь надо текущие дневные и недельные заменить на интервальные
 * Менять можно только в HeatingMode.HeatingZones
 * ОПТИМИЗАЦИЕЙ РАСПИСАНИЙ ЗАНИМАЕТСЯ ДРУГАЯ ФУНКЦИЯ
 * Старые DayTimetable.Id
 * [20506, 20507, 20606, 20607]
 * @param config - Z3KConfig
 * @return Z3KConfig
 */
export const changeSchedule2IntervalTimetable = (config) => {
    //Возьмём все режимы,
    // у которых в зонах настройки температуры похожи на ObjID
    return (HeatingMode.get
        .where(config, ({ heating_zones }) => heating_zones.some(({ temperature_setting }) => seemsLikeObjectId(temperature_setting)))
        // модифицируем их
        .reduce((new_config, mode) => {
        //Изменяем зоны с дневным и недельным расписанием
        const new_hzs = mode.heating_zones.map((hz) => {
            //Пробуем поменять ссылку и конфиг
            let new_temperature_setting;
            [new_temperature_setting, new_config] =
                changeSchedule2IntervalTimetableInHZ(new_config, hz.temperature_setting);
            //Если вернули null, значит не меняли зону
            if (new_temperature_setting == null) {
                return hz;
            }
            return {
                ...hz,
                temperature_setting: new_temperature_setting,
            };
        });
        return HeatingMode.get.applySetterById(new_config, mode.id, {
            heating_zones: new_hzs,
        });
    }, config));
};
/**
 * @function
 * Конвертирую дневное или недельное расписание
 * в интервальное расписание
 * в temperature_setting может быть температура в децикельвинах (2730)
 * ссылка на другой режим HeatingMode.Id
 * ссылка на дневное расписание DayTimetable.Id
 * ссылка на недельное WeekTimetable.Id
 * ссылка на интервальное IntervalTimetable.Id
 * @param config - Z3KConfig
 * @param temperature_setting - температурная настройка
 * @return [IntervalTimetable.Id[], Z3KConfig]
 */
const changeSchedule2IntervalTimetableInHZ = (config, temperature_setting) => {
    //Если это день
    const day = DayTimetable.get.one(config, 
    // prettier-ignore
    ({ id }) => id === temperature_setting);
    if (day != null) {
        return transformDay2It(config, day);
    }
    //Если это неделя
    const week = WeekTimetable.get.one(config, 
    // prettier-ignore
    ({ id }) => id === temperature_setting);
    if (week != null) {
        return transformWeek2It(config, week);
    }
    return [null, config];
};
/**
 * @function
 * Конвертирую дневное расписание в интервальное расписание
 * @param config - Z3KConfig
 * @param day - DayTimetable
 * @return [IntervalTimetable.Id[], Z3KConfig]
 */
export const transformDay2It = (config, day) => {
    const [new_ids, new_config] = day2ti(config, day);
    return IntervalTimetable.get.add(new_config, {
        ...IntervalTimetable.default_object,
        time_intervals: new_ids,
    });
};
/**
 * @function
 * Конвертирую дневное расписание в интервалы
 * @param config - Z3KConfig
 * @param day - DayTimetable
 * @param action_register - в какие дни действует этот день
 * @return [TimeInterval.Id[], Z3KConfig]
 */
const day2ti = (config, day, action_register = 127) => {
    const new_ids = [];
    const new_config = day.temp24
        .map((temp, index) => ({
        ...TimeInterval.default_object,
        temperature: temp,
        sh: index,
        eh: index !== 23 ? index + 1 : index,
        em: index !== 23 ? 0 : 59,
        action_register,
    }))
        .reduce((conf, ti) => {
        const [new_id, _config] = TimeInterval.get.add(conf, ti);
        new_ids.push(new_id);
        return _config;
    }, config);
    return [new_ids, new_config];
};
/**
 * @function
 * Конвертирую недельное расписание в интервальное расписание
 * @param config - Z3KConfig
 * @param week - WeekTimetable
 * @return [IntervalTimetable.Id[], Z3KConfig]
 */
export const transformWeek2It = (config, week) => {
    const [new_ids, new_config] = week2ti(config, week);
    return IntervalTimetable.get.add(new_config, {
        ...IntervalTimetable.default_object,
        time_intervals: new_ids,
    });
};
/**
 * @function
 * Конвертирую недельное расписание в интервалы
 * @param config - Z3KConfig
 * @param week - WeekTimetable
 * @return [TimeInterval.Id[], Z3KConfig]
 */
const week2ti = (config, week) => {
    let new_ids = [];
    const new_config = week.temp7.reduce((new_conf, 
    // prettier-ignore
    day_id, index) => {
        const day = DayTimetable.get.one(new_conf, 
        // prettier-ignore
        ({ id }) => id === day_id);
        if (day != null) {
            const [_new_ids, new_config] = day2ti(new_conf, day, 1 << index);
            new_ids = new_ids.concat(_new_ids);
            return new_config;
        }
        return new_conf;
    }, config);
    return [new_ids, new_config];
};
